@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div id="getStafCosting" (click)="loadData()"></div>
<div class="pdding flex flex-wrap">
  <button
    mat-flat-button
    color="accent"
    class="btn-height mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14"
    (click)="Addstaffcost('new')"
  >
    <mat-icon class="fs-17 t3">add</mat-icon>
    Add
  </button>
  <button
    [disabled]="dataSource?.data?.length <= 0 ? true : false"
    mat-flat-button
    color="accent"
    class="btn-height mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14"
    (click)="Addstaffcost('edit')"
  >
    <mat-icon class="fs-17 t3">edit</mat-icon>
    Edit
  </button>
  <button
    [disabled]="dataSource?.data?.length <= 0 ? true : false"
    mat-flat-button
    color="accent"
    class="btn-height mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14"
    (click)="deleteStafCost()"
  >
    <mat-icon class="fs-17 t3">delete</mat-icon>
    Delete
  </button>
</div>
<div class="table-container resizable-table">
  <!-- <div class="grid-overlay" *ngIf="dataSource?.data?.length <= 0">
  <div class="grid-overlay-msg"> There is no data to display. </div>
</div> -->
  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
    <!-- EFFECTIVE DATE Column -->
    <ng-container matColumnDef="EFFECTIVEDATE">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sticky>Effective Date</th>
      <td mat-cell *matCellDef="let element">
        {{ element.EFFECTIVEDATE }}
      </td>
    </ng-container>

    <!-- ANNUAL BILLING HOURS Column -->
    <ng-container matColumnDef="ANNUALBILLINGHOURS">
      <th mat-header-cell *matHeaderCellDef sticky>Annual Billing Hours</th>
      <td mat-cell *matCellDef="let element">
        {{ element.ANNUALBILLINGHOURS }}
      </td>
    </ng-container>

    <!-- COST PER BILLING HOUR Column -->
    <ng-container matColumnDef="COSTPERBILLINGHOUR">
      <th mat-header-cell *matHeaderCellDef sticky>Cost/hr</th>
      <td mat-cell *matCellDef="let element">
        {{ element.COSTPERBILLINGHOUR }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" sticky></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [style.background]="highlightedRows == row.USERSTAFFCOSTINGGUID ? selectedColore : ''"
      [ngClass]="highlightedRows == row.USERSTAFFCOSTINGGUID ? 'row-text-colore' : ''"
      (click)="highlightedRows = row.USERSTAFFCOSTINGGUID; getStafCostData(row)"
    ></tr>
  </table>
</div>
